import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { port } from "../../../../adblockplusui/adblockpluschrome/lib/messaging/port.js";
export function start() {
    port.on("testing.addFilter", async (message) => {
        await ewe.filters.add([message.text]);
    });
}
